var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";
import { DmpDocumentsSearchParams, DocumentStatus, DocumentVisibility } from "cnam/types/types";
import DocumentsRetrieveAccessFormSearchComponent from "cnam/components/documents-retrieve-access-form/search";
import DocumentsRetrieveAccessFormShowComponent from "cnam/components/documents-retrieve-access-form/show";
import { State } from "./abstract/cnam-context";
import DmpContext from "./abstract/dmp-context";
let DmpConsultationContext = (_class = class DmpConsultationContext extends DmpContext {
  constructor(cnamAdapterName, patient, medic, authenticationContext, dmpAdapter, insiAdapter, store, requestManager) {
    super(cnamAdapterName, patient, authenticationContext, dmpAdapter, insiAdapter, store, requestManager);
    _initializerDefineProperty(this, "patient", _descriptor, this);
    _initializerDefineProperty(this, "medic", _descriptor2, this);
    _initializerDefineProperty(this, "searchParams", _descriptor3, this);
    _initializerDefineProperty(this, "documents", _descriptor4, this);
    _initializerDefineProperty(this, "uniqueId", _descriptor5, this);
    _initializerDefineProperty(this, "currentDocumentMetadata", _descriptor6, this);
    _initializerDefineProperty(this, "currentDocumentContent", _descriptor7, this);
    _initializerDefineProperty(this, "webPSUrls", _descriptor8, this);
    this.patient = patient;
    this.medic = medic;
    this.authenticationContext = authenticationContext;
    this.dmpAdapter = dmpAdapter;
    this.reset();
    this.states = [...this.states, new State("load-links", () => {
      return Promise.resolve(!this.webPSUrls);
    }, async () => {
      this.webPSUrls = await this.dmpAdapter.td09GetWebPSURLs(this.patient.ins, this.secretConnection);
    }), new State("find-documents", () => {
      return Promise.resolve(!this.currentDocumentMetadata);
    }, async () => {
      this.documents = await this.findDocuments(this.patient, this.store, this.paramsToFilterCriteria(this.searchParams));
    }, DocumentsRetrieveAccessFormSearchComponent), new State("show-document", () => {
      return Promise.resolve(Boolean(this.currentDocumentMetadata));
    }, async () => {
      this.currentDocumentContent = await this.dmpAdapter.td32RetrieveContent(this.patient.ins, this.currentDocumentMetadata, this.secretConnection);
    }, DocumentsRetrieveAccessFormShowComponent)];
  }
  reset() {
    super.reset();
    this.searchParams = new DmpDocumentsSearchParams([], undefined, undefined, undefined, false, false, false, false, false);
    this.uniqueId = undefined;
    this.currentDocumentMetadata = undefined;
    this.currentDocumentContent = undefined;
    this.webPSUrls = undefined;
    this.successKey = undefined;
  }
  paramsToFilterCriteria(params) {
    const cnamApiParams = {
      typeCodes: params.typeCodes
    };
    const startDate = params.serviceStartTimeFrom ? new Date(params.serviceStartTimeFrom) : undefined;
    const endDate = params.serviceStopTimeTo ? new Date(params.serviceStopTimeTo) : undefined;
    endDate?.setHours(23, 59, 59);
    const submissionDate = params.submissionStartTimeFrom ? new Date(params.submissionStartTimeFrom) : undefined;
    cnamApiParams.serviceStartTimeFrom = startDate;
    cnamApiParams.serviceStopTimeTo = endDate;

    /// Submission Date

    cnamApiParams.submissionStartTimeFrom = submissionDate;

    /// Filters

    const statuses = [];
    if (params.archived) statuses.push(DocumentStatus.ARCHIVED);
    if (params.obsolete) statuses.push(DocumentStatus.DEPRECATED);
    if (statuses.length > 0) {
      cnamApiParams.statuses = statuses;
    }
    const confidentialities = [];
    if (params.hiddenToPatient) confidentialities.push(DocumentVisibility.HIDDEN_TO_PATIENT);
    if (params.hiddenToHealthcareProfessional) confidentialities.push(DocumentVisibility.HIDDEN_TO_HEALTHCARE_PROFESSIONAL);
    if (params.hiddenToLegalRepresentatives) confidentialities.push(DocumentVisibility.HIDDEN_TO_LEGAL_REPRESENTATIVES);
    if (confidentialities.length > 0) {
      cnamApiParams.visibilities = confidentialities;
    }
    return cnamApiParams;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "patient", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "medic", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "searchParams", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "documents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "uniqueId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currentDocumentMetadata", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentDocumentContent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "webPSUrls", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _class);
export { DmpConsultationContext as default };